import { useListCustomAttributes } from "#src/components/hooks/adapters/useCustomAttributes";
import { useMultiStepFormContext } from "#src/hooks/useMultiStepForm";
import {
  AssetType,
  AttributeDataType,
  FacilitySchema,
  Resources,
} from "@validereinc/domain";
import React from "react";
import {
  AssetDetailsFormStep,
  StaticFieldToDisplayType,
} from "#src/batteries-included-components/Panels/FormPanels/AssetDetailsFormPanel/AssetDetailsFormStep";
import { Facilities } from "@validereinc/domain-controllers";

const { FacilityStatusOptions } = Facilities.view;

export const FacilityDetailsFormStep = () => {
  const { getStep } = useMultiStepFormContext();
  const prevStep = getStep(1);
  const prevStepValues = prevStep?.getValues();

  const customAttributesQuery = useListCustomAttributes({
    filters: { entity_type: AssetType.FACILITY },
  });

  const customAttributes = customAttributesQuery.data?.data ?? [];

  const staticFieldsToDisplay: StaticFieldToDisplayType[] = [
    {
      field_name: FacilitySchema.keyof().Enum.status,
      display_name: "Status",
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values: FacilityStatusOptions.map((option) => ({
        id: option.value,
        name: option.label,
      })),
      is_required: true,
    },
    {
      field_name: "coordinates",
      display_name: "Coordinates",
      data_type: AttributeDataType.GEO_POINT,
      is_required: false,
    },
    ...customAttributes
      .filter((custom_attribute) =>
        custom_attribute.entity_subtypes
          ? custom_attribute.entity_subtypes.includes(
              prevStepValues?.type_id as string
            )
          : true
      )
      .sort((a, b) => Number(b.is_required) - Number(a.is_required))
      .map((custom_attribute) => {
        return {
          ...custom_attribute,
          field_name: `custom_attributes.${custom_attribute.field_name}`,
        } as typeof custom_attribute;
      }),
  ];

  return (
    <AssetDetailsFormStep
      resourceType={Resources.FACILITY}
      staticFieldsToDisplay={staticFieldsToDisplay}
    />
  );
};
